export default "__VITE_PUBLIC_ASSET__8c0b4cda__"